import * as XLSX from 'xlsx';
import { StudentData, SelfEval, PeerEval, TeacherGroupEval } from '../types';
import { convertPolarity } from './polarity';

interface RawStudentRow {
  学号?: string;
  姓名?: string;
  班级?: string;
  组别?: string;
  自评Q1?: number | string;
  自评Q2?: number | string;
  自评Q3?: number | string;
  自评Q4?: number | string;
  自评Q5?: number | string;
  自评Q6?: number | string;
  自评Q7?: number | string;
  自评Q8?: number | string;
  综合评价?: number | string;
  互评Q1?: number | string;
  互评Q2?: number | string;
  互评Q3?: number | string;
  互评Q4?: number | string;
  师评Q1?: number | string;
  师评Q2?: number | string;
  师评Q3?: number | string;
  师评Q4?: number | string;
}

function parseValue(val: number | string | undefined): number {
  if (val === undefined || val === null) return 0;
  if (typeof val === 'number') return val;
  const trimmed = val.trim();
  if (trimmed === '') return 0;
  const parsed = parseInt(trimmed, 10);
  return isNaN(parsed) ? 0 : parsed;
}

export function parseExcelToStudentData(buffer: ArrayBuffer): StudentData[] {
  const workbook = XLSX.read(buffer, { type: 'buffer' });
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  const jsonData = XLSX.utils.sheet_to_json<RawStudentRow>(worksheet);

  return jsonData.map((row) => {
    const studentId = `${row.班级 || 'unknown'}_${row.学号 || '0'}`;
    const selfEval: SelfEval = {
      q1Participation: convertPolarity('self', 'q1', parseValue(row.自评Q1)),
      q2Resilience: convertPolarity('self', 'q2', parseValue(row.自评Q2)),
      q3SkillKnow: convertPolarity('self', 'q3', parseValue(row.自评Q3)),
      q4SkillImprove: convertPolarity('self', 'q4', parseValue(row.自评Q4)),
      q5HealthSafe: convertPolarity('self', 'q5', parseValue(row.自评Q5)),
      q6HealthPrep: convertPolarity('self', 'q6', parseValue(row.自评Q6)),
      q7MoralQueue: convertPolarity('self', 'q7', parseValue(row.自评Q7)),
      q8MoralEncourage: convertPolarity('self', 'q8', parseValue(row.自评Q8)),
      overallEval: parseValue(row.综合评价),
    };

    const peerEval: PeerEval | undefined = (row.互评Q1 || row.互评Q2 || row.互评Q3 || row.互评Q4)
      ? {
          q1Emotion: convertPolarity('peer', 'q1', parseValue(row.互评Q1)),
          q2Support: convertPolarity('peer', 'q2', parseValue(row.互评Q2)),
          q3SafeRespect: convertPolarity('peer', 'q3', parseValue(row.互评Q3)),
          q4Effort: convertPolarity('peer', 'q4', parseValue(row.互评Q4)),
        }
      : undefined;

    const teacherGroupEval: TeacherGroupEval | undefined = (row.师评Q1 || row.师评Q2 || row.师评Q3 || row.师评Q4)
      ? {
          q1Complete: parseValue(row.师评Q1),
          q2Attitude: parseValue(row.师评Q2),
          q3Discipline: parseValue(row.师评Q3),
          q4Atmosphere: parseValue(row.师评Q4),
        }
      : undefined;

    return {
      student: {
        studentId,
        studentName: row.姓名 || '未知',
        className: row.班级 || '未知',
        groupId: row.组别 || '未知',
      },
      selfEval,
      peerEval,
      teacherGroupEval,
    };
  });
}